import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCamera5"><Path fillRule="evenodd" clipRule="evenodd" d="M11 4V15H22V21H2V4H11ZM9 16H5V18H9V16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13 4H22V13H13V4ZM17.5 9.75C16.8096 9.75 16.25 9.19036 16.25 8.5C16.25 7.80964 16.8096 7.25 17.5 7.25C18.1904 7.25 18.75 7.80964 18.75 8.5C18.75 9.19036 18.1904 9.75 17.5 9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera5;
